import { render, staticRenderFns } from "./goodGird.vue?vue&type=template&id=07096bae&"
import script from "./goodGird.vue?vue&type=script&lang=js&"
export * from "./goodGird.vue?vue&type=script&lang=js&"
import style0 from "./goodGird.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports